var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMobile28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 3,
  width: 12,
  height: 22,
  rx: 2,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11 4V5C11 5.2761 11.2238 5.5 11.5 5.5H16.5C16.7761 5.5 17 5.2761 17 5V4",
  stroke: "currentColor",
  strokeWidth: 1,
  fill: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 20H18",
  stroke: "currentColor",
  strokeWidth: 1
})));
export default SvgMobile28;